export default __webpack_public_path__ + "static/media/instagram.062f3339.svg";